import * as React from 'react'
import Layout from 'src/components/layout'
import { graphql } from 'gatsby'
import Hero from 'src/components/sections/hero'
import SplitSectionWithIcons from 'src/components/sections/SplitSectionWithIcons'
import TeaserWithHighlight from 'src/components/sections/teaser/TeaserWithHighlight'
import ContactSection from 'src/components/sections/ContactSection'
import AppPromoSection from 'src/components/sections/app-promo'
import { getPageContent } from 'src/helpers/pageContent'

const IndexPage = ({ data, pageContext }: any) => {
  const language = pageContext?.language || 'en'
  const translation = data?.directus?.pages?.[0]?.translations?.[0]
  const cmsJson = getPageContent('/sport', language, translation?.content)

  if (!cmsJson || Object.keys(cmsJson).length === 0) {
    return <h1>Missing translation</h1>
  }
  return (
    <Layout title={cmsJson.title} metas={cmsJson.metas}>
      <Hero translationContent={cmsJson.mainSection} />
      <TeaserWithHighlight
        translationContent={cmsJson.firstSection}
        splitRatio='7/12'
        imageMarginTop='md:pt-64'
      />
      <TeaserWithHighlight
        translationContent={cmsJson.goalsSection}
        hideImage
        listLayout="interactive-rows"
        ctaVariant='link'
      />
      <TeaserWithHighlight
        translationContent={cmsJson.solutionsSection}
        splitRatio='7/12'
        imageMarginTop='md:pt-64'
      />
      <SplitSectionWithIcons
        translationContent={cmsJson.expertiseSection}
      />
      <AppPromoSection translationContent={cmsJson.rosaSection} />
      <ContactSection />
    </Layout>
  )
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    directus {
      pages(filter: { slug: { _eq: "/sport" } }) {
        translations(filter: { languages_code: { code: { _eq: $language } } }) {
          content
        }
      }
    }
  }
`

export default IndexPage
